// The page builder's loading state: a quiet spinning ring. `fill` covers the
// whole screen (the editor while its page loads); otherwise it sits centered
// in the space it is given.
export function Loading({ label = 'Loading', fill = false, className = '' }: {
  /** Read out by screen readers. */
  label?: string;
  fill?: boolean;
  className?: string;
}) {
  return (
    <div className="pe-scope">
      <div className={`pe-loading${fill ? ' pe-loading--fill' : ''} ${className}`} role="status" aria-label={label}>
        <span className="pe-loading-ring" aria-hidden="true" />
      </div>
    </div>
  );
}
